import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  ModalInfo,
  Radio,
  Input
} from 'shared/components';
import Parser from 'html-react-parser';
import './MarkAsDeniedModal.scss';

const reasons = {
  noId:'no_id',
  late: 'late',
  other: 'other'
}

const MarkAsDeniedModal = ({
  modalIsOpen,
  closeModal,
  numberOfSelectedExaminees,
  onSubmit
}) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [fieldErrorMessage, setFieldErrorMessage] = useState('');
  const [noIdReasonValue, setNoIdReasonValue] = useState('');
  const [lateReasonValue, setLateReasonValue] = useState('');
  const [optionalReasonValue, setOptionalReasonValue] = useState('');
  const [otherReasonValue, setOtherReasonValue] = useState('');

  const testCenterCycle = useSelector((state) => state.tcEvent.testCenterCycle || {});

  const onSubmitHandle = (selected, otherReasonValue) => {
    setErrorMessage('')
    if(!selected){
      setErrorMessage(t('roomRoster.provideReason'));
    }

    if(selected === reasons.other && !otherReasonValue){
      setFieldErrorMessage(t('errors.fieldMandatory'));
    }

    if(selected === reasons.other && otherReasonValue){
      onSubmit(false, selected, otherReasonValue);
    }

    if(selected && selected !== reasons.other){
      onSubmit(false, selected, optionalReasonValue);
    }
  }

  const resetValues = () => {
    setOptionalReasonValue('');
    setNoIdReasonValue('');
    setLateReasonValue('');
    setOtherReasonValue('');
    setErrorMessage('');
    setFieldErrorMessage('');
  }

  const handleOptionChange = (e) => {
    resetValues();
    setSelected(e.target.value);
  };

  const handleNoIdInputValueChange = (e) => {
    setNoIdReasonValue(e.target.value);
    setOptionalReasonValue(e.target.value);
  };
  const handleLateInputValueChange = (e) => {
    setLateReasonValue(e.target.value);
    setOptionalReasonValue(e.target.value);
  };
  const handleOtherInputValueChange = (e) => {
    setFieldErrorMessage('');
    setOtherReasonValue(e.target.value);
  };

  useEffect(() => {
    if (modalIsOpen) {
      resetValues();
      setSelected('');
    }
  }, [modalIsOpen]);

  return (
    <div>
      <ModalInfo
        containerClass="mark-as-denied-modal-container"
        onSubmit={() => onSubmitHandle(selected, otherReasonValue)}
        modalIsOpen={modalIsOpen}
        onCancel={closeModal}
        className='mark-as-denied-modal'
        saveLabel={t('roomRoster.markAsDenied')}
        cancelLabel="Cancel"
        showCancel
      >
        <h5>{t('roomRoster.markAsDeniedQuestion')}</h5>
        <div>{Parser(t(testCenterCycle?.testCenterProgram?.program.parentCode === 'workkeys'
          ? 'roomRoster.markAsDeniedTextWK'
          : 'roomRoster.markAsDeniedText', { number: numberOfSelectedExaminees }))}</div>

        <div className="form-check form-check-inline">
          <div className="radio-input">
            <Radio
              value={reasons.noId}
              label={t('roomRoster.noId')}
              checked={selected === reasons.noId}
              onChange={handleOptionChange}
              />
          </div>
          <Input
            className={`deny-input ${selected === reasons.noId && 'active'}`}
            type="text"
            name={reasons.noId}
            id={reasons.noId}
            value={noIdReasonValue}
            onChange={handleNoIdInputValueChange}
            onFocus={() => setErrorMessage('')}
            placeholder={t('roomRoster.provideAdditionalDetailsOptional')}
          />
          <div className="radio-input">
            <Radio
              value={reasons.late}
              label={t('roomRoster.late')}
              checked={selected === reasons.late}
              onChange={handleOptionChange}
              />
          </div>
          <Input
            className={`deny-input ${selected === reasons.late && 'active'}`}
            type="text"
            name={reasons.late}
            id={reasons.late}
            value={lateReasonValue}
            onChange={handleLateInputValueChange}
            onFocus={() => setErrorMessage('')}
            placeholder={t('roomRoster.provideAdditionalDetailsOptional')}
          />
          <div className="radio-input">
            <Radio
              value={reasons.other}
              label={t('roomRoster.other')}
              checked={selected === reasons.other}
              onChange={handleOptionChange}
              />
              {errorMessage &&
              <span className='error small'>{t(errorMessage)}</span>
              }
          </div>
          <Input
            className={`deny-input ${selected === reasons.other && 'active'}`}
            containerClassName={`deny-input-container ${selected === reasons.other && 'active-container'}`}
            type="text"
            name={reasons.other}
            id={reasons.other}
            value={otherReasonValue}
            onChange={handleOtherInputValueChange}
            onFocus={() => setErrorMessage('')}
            placeholder={t('roomRoster.provideReasonPlaceholder')}
            errors={fieldErrorMessage}
            required
          />
        </div>
        
      </ModalInfo>
    </div>
  );
};

export default MarkAsDeniedModal;
